import type { ForgeUIAnalyticsContext } from '@atlassian/xen-editor-provider';
import { ProductEnvironment } from '@atlassian/xen-editor-provider';

// Refer to ForgeUIExtensionDataType in @confluence/forge-ui for typing of this object
// Couldn't directly import it & type the return because of circular dependency issues
export const createForgeMacroExtensionData = ({
	contentId,
	contentType,
	contentVersion,
	contentStatus,
	spaceKey,
	spaceId,
	isLivePage,
	templateId,
}: {
	contentId: string;
	contentType: string | undefined;
	contentVersion?: number;
	contentStatus?: string;
	spaceKey: string;
	isLivePage: boolean;
	spaceId?: string;
	templateId?: string;
}): {
	template?:
		| {
				id: string;
		  }
		| undefined;
	type: string;
	content: {
		id: string;
		type: string | undefined;
		subtype: string | null;
		version: number | undefined;
		status: string | undefined;
	};
	space: {
		key: string;
		id: string | undefined;
	};
} => ({
	type: 'macro',
	content: {
		id: contentId,
		type: contentType,
		subtype: isLivePage ? 'live' : null,
		version: contentVersion,
		status: contentStatus,
	},
	space: {
		key: spaceKey,
		id: spaceId,
	},
	...(templateId && { template: { id: templateId } }),
});

export function createForgeUIAnalyticsContext({
	objectId,
	objectType,
	containerId,
	containerType,
}: {
	objectId: string;
	objectType: 'page' | 'blogpost' | null;
	containerId: string | null;
	containerType: 'space';
}): ForgeUIAnalyticsContext {
	return {
		objectId,
		objectType: objectType || undefined,
		containerId: containerId || undefined,
		containerType,
	};
}

export function environmentToForgeProductEnvironment(environment: string): ProductEnvironment {
	return (
		// In dev, proxying to a site will give that site's environment,
		// which is not what we want
		window.location.hostname === 'localhost'
			? ProductEnvironment.DEVELOPMENT
			: environment === 'STAGING'
				? ProductEnvironment.STAGING
				: environment === 'PRODUCTION'
					? ProductEnvironment.PRODUCTION
					: ProductEnvironment.DEVELOPMENT
	);
}
